module.exports = {
  API_ROOT_URL                : "https://api-production.secondmeal.io",
  WEB_ROOT_URL                : "https://www.secondmeal.sg",
  KLANGA_ROOT_URL             : "https://api.klanga.io",
  KLANGA_API_KEY              : "XUDcmru6o223akg00fo2k8g65b7e36015ae290ac79a87f7",
  STRIPE_PUBLISHABLE_KEY      : "pk_live_Aypfy5bLJOMhv6rr7hreTXmT",
  GOOGLE_ANALYTICS_TRACKING_ID: "UA-148577675-2"
};
